import script from "./ChiTietXuatTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChiTietXuatTable.vue?vue&type=script&setup=true&lang=ts"

import "./ChiTietXuatTable.vue?vue&type=style&index=0&id=ef020d46&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef020d46"]])

export default __exports__